import { Card, Grid, Typo } from "#/atoms";
import { FC, memo } from "react";
import { OrderServiceListCardProps } from "./OrderServiceList.interface";
import { PRIMARY_BLUE } from "@/theme";

const OrderServiceListCard: FC<OrderServiceListCardProps> = ({
  services
}) => {
  return (
    <Card>
      { services.filter(service => service.checked).map((service, index) => (
       <Grid key={index} margin="10px 0px" gridTemplateColumns="repeat(2, 1fr)" noRevert={true} justifyContent="space-between">
          <Typo>{service.name}</Typo>
          <Typo fontColor={PRIMARY_BLUE.DARK} textAlign={'right'}>x{service.defaultAmount}</Typo>
        </Grid>
      ))}
    </Card>
  );
};

export default memo(OrderServiceListCard);